export default __webpack_public_path__ + "static/React-1be9da0ea985814dc2b65a2043bb130c.svg";